import { computed, ComputedRef } from 'vue'

import { YesNoEnum } from '@collector/sportsapi-client-legacy'
import { UpdateEvent } from '@mobile/ActionQueue/Actions/Actions'
import { ButtonColor } from '@mobile/components/Button/ButtonTypes'

import { useEventInjections } from '../RelationDependencies/useEventInjections'

export type UseVerifyStatistics = {
  isStatsVerified: ComputedRef<boolean>
  statsButtonColor: ComputedRef<ButtonColor>
  isStatsButtonDisabled: ComputedRef<boolean>
  verifyStatisticsButtonText: ComputedRef<string>
  verifyStatistics: () => void
}

export function useVerifyStatistics(): UseVerifyStatistics {
  const { actionQueue, probableEvent } = useEventInjections()

  const isResultVerified = computed(
    () => probableEvent.value.verified_result === YesNoEnum.Yes,
  )

  const isStatsVerified = computed(
    () => probableEvent.value.is_stats_verified === YesNoEnum.Yes,
  )

  const statsButtonColor = computed(() =>
    isStatsVerified.value ? 'green' : 'gray',
  )

  const isStatsButtonDisabled = computed(
    () => !isResultVerified.value || isStatsVerified.value,
  )

  const verifyStatisticsButtonText = computed(() =>
    isStatsVerified.value ? 'Statistics verified' : 'Verify statistics',
  )

  const verifyStatistics = (): void =>
    actionQueue.value.add(
      new UpdateEvent({
        event: { is_stats_verified: YesNoEnum.Yes },
      }),
    )

  return {
    isStatsVerified,
    statsButtonColor,
    isStatsButtonDisabled,
    verifyStatisticsButtonText,
    verifyStatistics,
  }
}
